import { BaseEntity } from './BaseEntity';

export class BaseNotes extends BaseEntity {
  // timeStamp: Date | string;
  note: string;
}
